<template>
	<span class="flex items-baseline gap-1 whitespace-nowrap">
		<span v-if="priceData.show_prefix" class="price-prefix">{{ priceData.prefix }}</span>
		<span v-if="fromPriceFormatted" :class="['line-through price-from', { 'text-red-600': highlightFromPrice }]">
			{{ fromPriceFormatted }}
		</span>
		<span class="price-amount">
			{{ selectedDate === 'none' ? priceData.lowest_price_formatted : priceData.price_formatted }}
			<span v-if="priceData.show_suffix && !hideSuffix">{{ priceData.suffix }}</span>
		</span>
	</span>
</template>

<script setup lang="ts">
import { computed } from "vue";
import { BuyablePriceData } from "../api/resources";

export type Props = {
  priceData: BuyablePriceData,
  selectedDate: string,
  hideSuffix?: boolean,
  highlightFromPrice?: boolean,
}

const props = defineProps<Props>();

const fromPriceFormatted = computed(() =>
  props.selectedDate === 'none' ? props.priceData.from_lowest_price_formatted : props.priceData.from_price_formatted,
);
</script>
